import React from 'react';
import { Table, Button, Row, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

interface Invoice {
  id: number;
  invoice_number: string;
  total: string;
  status: string;
  created_at: string;
}

interface PaymentsInfoProps {
  id: string | null;
  pr_code: string | null;
  invoice_data: Invoice[];
  ImpStatus?: string | null;
  wfActions?: string[];
}

const PaymentsInfo: React.FC<PaymentsInfoProps> = ({ id, pr_code, invoice_data, ImpStatus, wfActions }) => {
  const navigate = useNavigate();
  const moduleType = 'IMPORT';

  const showInvoice = (
    invoiceId: number,
    status: string,
    invoice_number: string,
    total: string,
    moduleType: string,
  ) => {
    if (id !== null) {
      navigate(`/import-invoice`, {
        state: { id, pr_code, invoiceId, status, invoice_number, ImpStatus, wfActions, total, moduleType },
      });
    } else {
      notification.error({ message: 'Error', description: 'Invalid ID or Invoice' });
    }
  };

  const invoiceColumns = [
    {
      title: 'Invoice Number',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => <span style={{ color: status === 'PAID' ? 'green' : 'red' }}>{status}</span>,
    },
    {
      title: 'Total (LKR)',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: Invoice) => (
        <Row align="middle">
          <Button
            size="small"
            type="primary"
            onClick={() => showInvoice(record.id, record.status, record.invoice_number, record.total, moduleType)}
          >
            View
          </Button>
        </Row>
      ),
    },
  ];

  return (
    <>
      <h3>Invoices</h3>
      <Table dataSource={invoice_data} columns={invoiceColumns} rowKey="id" />

      <h3>Receipts</h3>
      <p>No receipts available yet.</p>
    </>
  );
};

export default PaymentsInfo;
